import { FC } from 'react';
import { CatHeading } from '@blocks-react/components/Heading';
import { LocationMapDetailsProps } from '../types';
import styles from '../alp.module.scss';
import cx from 'classnames';

export const LocationMapDetails: FC<LocationMapDetailsProps> = ({
  link,
  content,
  className,
  contentClassName,
  variant = 'label',
  isEllipses = false
}) => {
  return (
    <CatHeading variant={variant} className={`align-middle ${className}`}>
      {content ? (
        <a
          href={link}
          rel="noreferrer noopener"
          target="_blank"
          className={contentClassName}
        >
          <div
            className={cx({ [styles['location-link-ellipses']]: isEllipses })}
          >
            {content}
          </div>
        </a>
      ) : (
        <span>-</span>
      )}
    </CatHeading>
  );
};
